import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { MessageService } from 'primeng/api';
import { ApiService } from 'src/app/shared/services/api.service';
import { ISearchBody } from 'src/app/shared/interfaces/searchBody';
import { IDoctor } from 'src/app/shared/interfaces/doctor';
import { EDoctorStatus } from 'src/app/shared/interfaces/doctorStatus-enum';
import { ICategoryOut } from 'src/app/shared/interfaces/categoryOut';

@Component({
  selector: 'app-doctors',
  templateUrl: './doctors.component.html',
  styleUrl: './doctors.component.css',
  providers: [MessageService]
})
export class DoctorsComponent implements OnInit {

  drStatusModel: EDoctorStatus;
  drStatus: number;
  drId: any;
  doctorsList: IDoctor[];
  categoriesList: ICategoryOut[];
  searchInp = {
    title: '',
    pageIndex: 1,
    medicalCategoryId: null,
    status: null
  };
  doctorStatus = EDoctorStatus;

  first: number = 0 ;
  rows: number = 10;
  pageSize = 10;  
  currentpage = 1;
  collectionSize: number = 10;

  @ViewChild('modal') modal!: ModalComponent;


  constructor(
    public apiService: ApiService,
    private messageService: MessageService,
                
  ) {}

  ngOnInit(): void {
    this.getCategoriesList();
    this.getDoctorsList(0);
  }

  getDoctorsList(page) {
    this.searchInp = {
      title: this.searchInp.title,
      pageIndex: page+1,
      medicalCategoryId: this.searchInp.medicalCategoryId!=null?Number(this.searchInp.medicalCategoryId):null,
      status: this.searchInp.status!=null?Number(this.searchInp.status):null
    };

    console.log(this.searchInp);
    
    
    this.apiService.apiCall('post', '/api/Doctor/GetAll', this.searchInp).subscribe((res: any) => {
      console.log(res);
      
      this.doctorsList = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })
  }

  getCategoriesList() {
    const searchBody = {
      pageIndex: 1,
      pageSize: 200
    }

    this.apiService.apiCall('post', '/api/Category/GetAll/1/0', searchBody).subscribe((res: any) => {
      console.log(res);
      this.categoriesList = res.body.model;
    })
  }

  changeDrStatus() {
    
    this.apiService.apiCall('post', '/api/Doctor/changeDoctorStatus/'+ this.drId+'/'+this.drStatus).subscribe((res: any) => {
      console.log(res);

      if (res.body.isSuccess == true) {
        this.modal.close();

        this.messageService.add({severity: 'success', summary: 'موفق', detail: ' تغییر وضعیت پزشک با موفقیت انجام شد' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail:  res.body.message});
      }
      
    })
  

  // showToast() {
  //   this.messageService.add({severity: 'error', summary:  'Heading', detail: 'More details....' });
    
  }

}
